export default function InfoCircleIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM18 10C18 5.58172 14.4183 2 10 2C5.58378 2.00496 2.00496 5.58378 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10ZM11 5V7H9V5H11ZM11 9V15H9V11H8V9H11Z"
        fill="currentColor"
      />
    </svg>
  );
}
